import { SAVE_FOR_LATER_CAROUSEL_MAX_ITEMS } from 'constants/saveForLater';
import Empty from 'constants/empty';

/**
 * Transform Save For Later API item to ProductCard-compatible SKU format
 * @param {object} item - Save For Later item from API (shoppingListItems)
 */
function transformSaveForLaterItemToSku(item) {
    if (!item?.sku) {
        return null;
    }

    const { sku } = item;
    const gridImageURL = sku.skuImages?.image250;

    return {
        id: sku.productId,
        productId: sku.productId,
        skuId: sku.skuId,
        productName: sku.productName,
        brandName: sku.brandName,
        listPrice: sku.listPrice,
        salePrice: sku.salePrice,
        currentPrice: sku.salePrice || sku.listPrice,
        isOnSale: sku.onSaleSku || false,
        gridImageURL,
        skuImages: gridImageURL ? [{ src: gridImageURL }] : Empty.Array,
        variationValue: sku.variationValue,
        variationDesc: sku.variationDesc,
        badges: Empty.Array,
        badgeAltText: sku.badgeAltText,
        targetUrl: sku.targetUrl,
        isAvailable: sku.isActive && !sku.isOutOfStock,
        isOutOfStock: sku.isOutOfStock,
        isWithBackInStockTreatment: sku.isWithBackInStockTreatment,
        actionFlags: sku.actionFlags,
        maxPurchaseQuantity: sku.maxPurchaseQuantity
    };
}

/**
 * Prepare Save For Later carousel data for rendering
 * @param {object} options - Configuration options
 * @param {boolean} options.isEnabled - Whether Save For Later feature is enabled
 * @param {Array} options.items - Raw Save For Later items from API
 * @param {string} options.listId - Shopping list ID
 * @param {number} [options.maxItems=10] - Maximum items to show in carousel (additional items are truncated but total count preserved)
 * @returns {object|null} Carousel data or null if feature disabled or no items
 */
function prepareSaveForLaterCarouselData({ isEnabled, items, listId, maxItems = SAVE_FOR_LATER_CAROUSEL_MAX_ITEMS }) {
    if (!isEnabled || !Array.isArray(items) || items.length === 0) {
        return null;
    }

    const skuList = items
        .map(transformSaveForLaterItemToSku)
        .filter(sku => sku !== null)
        .slice(0, maxItems);

    return skuList.length === 0 ? null : { skuList, totalItems: items.length, listId };
}

export default {
    transformSaveForLaterItemToSku,
    prepareSaveForLaterCarouselData
};
